// FeePlanCancelled.js
import React, { useEffect } from "react";

const FeePlanCancelled = () => {
  useEffect(() => {
    // Replace history so user cannot go back
    window.history.replaceState(null, "", window.location.href);

    const handlePopState = () => {
      // Try closing the tab
      window.close();

      // // Fallback: redirect to an external page if close is blocked
      // setTimeout(() => {
      //   window.location.href = "https://www.google.com";
      // }, 100);
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  return (
    <div className="d-flex vh-100 vw-100 justify-content-center align-items-center bg-light">
      <div
        className="text-center p-4"
        style={{
          maxWidth: "600px",
          width: "100%",
          border: "none",
          boxShadow: "none",
          backgroundColor: "transparent",
        }}
      >
        <h2 className="mb-3" style={{ color: "red" }}>
          Action Cancelled
        </h2>
        <p className="mb-4">
          You have cancelled the process. Attempting to close this page.
        </p>
      </div>
    </div>
  );
};

export default FeePlanCancelled;
